import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import Pagination from "src/component/Global/Pagination"
import NoResultContent from '../NoResultContent';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { __remove, __set } from 'src/store/axios_indicator';
import Constants from 'src/helper/Constants';
import ReusableDiv from 'src/helper/ReusableDiv';
import Helper from 'src/helper/Helper';
import ContentTabCommonSorting from '../ContentTabs/ContentTabCommonSorting';

const NewProductInformationTabContent = () => {
    const [list, setList] = useState([]);
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [searchParams] = useSearchParams();
    const [total, setTotal] = useState(0);
    const [__check] = useAxiosIndicatorCheck();
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: 'Relevance',
    });

    const [{ }, { get_home_page_content }, { set_individual_tabs_count }] = useHomePageContentStore();
    const { homePageAllTabs } = Constants;

    useEffect(() => {
        const getList = async () => {
            await fetchAPiCall(firstServerCall);
            setFirstServerCall(false);
        };
        getList();
    }, []);

    useEffect(() => {
        if (!firstServerCall) fetchAPiCall();
        Helper.scrollTop();
    }, [listObj.page, listObj.limit, listObj.sortBy]);

    const fetchAPiCall = async (defaultStart = false) => {
        __set('NEW_PRODUCT_INFORMATION_API_CALL');
        const search_keyword = searchParams.get('search');
        const data = await get_home_page_content({
            pageNumber: defaultStart ? 1 : listObj.page,
            pageSize: listObj.limit,
            orderBy: listObj.sortBy,
            searchTerm: search_keyword,
            contentType: homePageAllTabs.NPI.contentType,
        });

        setList(data[homePageAllTabs.NPI.contentType].webContentView);
        const total = data[homePageAllTabs.NPI.contentType].totalCount;
        setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) });
        setTotal(total);
        set_individual_tabs_count('npiCount', total);
        __remove('NEW_PRODUCT_INFORMATION_API_CALL');
    };

    const handlePageClick = (data) => {
        setListObj({ ...listObj, page: data.selected + 1 });
    };

    const setPageLimit = (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
    };

    const onFilter = (e) => {
        setListObj({ ...listObj, sortBy: e.target.value });
    };

    return (
        <>
            <div className="filter-records">
                <span>Showing {total} content results for <b>"{searchParams.get('search')}"</b></span>
            </div>
            <div className='new-content-wrapper'>
                <div className='bs5 container-fluid maxw-auto'>
                    <div className='bs5 row mt-3'>
                        <div className='col-lg-9 tab-data'>
                            <div className='all-content'>

                                <ContentTabCommonSorting onFilter={onFilter} headerNme={homePageAllTabs.NPI.tabHeader} dataLength={list.length} />

                                <hr />
                                <div className="position-relative">
                                    {__check(['NEW_PRODUCT_INFORMATION_API_CALL'], { overlay: true }).render}
                                    <div className="all-content-body">
                                        {list.length > 0 ? (
                                            list.map((v, i) => (
                                                <div key={i} className="all-content-body-item">
                                                    <div className="font-16 text-blue2 font-bold mb-1">
                                                        <a href={v?.url} target="_blank" rel="noopener noreferrer">{v.name}</a>
                                                    </div>
                                                    <div className="ellipses" title={v.shortDescription}>
                                                        {v.shortDescription}
                                                    </div>
                                                    <hr />
                                                </div>
                                            ))
                                        ) : (
                                            !firstServerCall && (
                                                <NoResultContent message={`No Results Found for <b>"${searchParams.get('search')}"</b>`} />
                                            )
                                        )}
                                    </div>
                                    {list.length > 0 && (
                                        <div className="pagination-row">
                                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 tab-sidebar">
                            {ReusableDiv.newsLetterAd()}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NewProductInformationTabContent;
